(function () {
  function normalize(str) {
    return (str || '').trim().toLowerCase();
  }
  function parseSelected(paramKey) {
    const url = new URL(window.location.href);
    const raw = url.searchParams.get(paramKey);
    if (!raw) return [];
    return raw.split(',').filter(Boolean).map(v => {
      // Decode '+' as space before decodeURIComponent
      const withSpaces = v.replace(/\+/g, '%20');
      return normalize(decodeURIComponent(withSpaces));
    });
  }

  function buildUrl(paramKey, values) {
    const url = new URL(window.location.href);

    if (values.length > 0) {
      const paramValue = values.join(',');
      url.searchParams.set(paramKey, paramValue);
    } else {
      url.searchParams.delete(paramKey);
    }

    return url.toString();
  }

  function sendAnalytics(eventName, eventLabel, meta = {}) {
    if (!eventName || !eventLabel) return;

    const payload = {
      event_category: 'Sub-filter Rail',
      event_label: eventLabel,
      category_id: meta.category_id || meta.categoryId || '',
      category_url: meta.category_url || meta.categoryUrl || '',
      category_name: meta.category_name || meta.categoryName || ''
    };

    Object.keys(payload).forEach((key) => {
      if (payload[key] === '' || payload[key] == null) {
        delete payload[key];
      }
    });

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, payload);
        return;
      }
    } catch (e) {}

    try {
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: eventName, ...payload });
      }
    } catch (e) {}
  }

  function init(container) {
    const paramKey = container.getAttribute('data-param-key') || 'f.Category';
    const list = container.querySelector('.zop-top-filters__list');
    if (!list) return;
    const buttons = Array.from(list.querySelectorAll('.zop-top-filters__item'));
    const selected = new Set(parseSelected(paramKey));
    const categoryMeta = {
      category_id: container.getAttribute('data-category-id') || '',
      category_url: container.getAttribute('data-category-url') || window.location.href,
      category_name: container.getAttribute('data-category-name') || ''
    };
    const impressionLabel = container.getAttribute('data-impression-label') || "";
    let impressionSent = false;
    
    // Helper to update filter button states and reorder
    function updateFilterButtons(selectedSet, focusBtn) {
      buttons.forEach(btn => {
        const filters = (btn.getAttribute('data-filters') || '').split(',').map(s => normalize(s)).filter(Boolean);
        const isActive = filters.every(f => selectedSet.has(f));
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      reorder(focusBtn);
    }

    // Initialize pressed state and order
    updateFilterButtons(selected);

    // Recalculate pressed state from current URL param and reorder.
    function refreshFromUrl() {
      const newSelected = new Set(parseSelected(paramKey));
      selected.clear();
      newSelected.forEach(v => selected.add(v));
      updateFilterButtons(selected);
    }
    
    // Global clear buttons
    document.addEventListener('click', function(e){
      const el = e.target.closest && e.target.closest('.filter-clear, .st-reset-all-mobile');
      if(el){
        requestAnimationFrame(refreshFromUrl);
      }
    });

    // Special case: Not working with global listener
    Array.from(document.querySelectorAll('.filter-clear')).forEach(function(el) {
      el.addEventListener('click', function() {
        requestAnimationFrame(refreshFromUrl);
      });
    });

    // Click + keyboard
    function toggle(btn) {
      const filters = (btn.getAttribute('data-filters') || '').split(',').map(s => normalize(s)).filter(Boolean);
      const isActive = btn.getAttribute('aria-pressed') === 'true';
      if (isActive) {
        filters.forEach(f => selected.delete(f));
      } else {
        filters.forEach(f => selected.add(f));
      }
      // Update pressed state and reorder using shared function
      updateFilterButtons(selected, btn);
      const url = buildUrl(paramKey, Array.from(selected));
      window.history.replaceState({}, "", url);
      window.postMessage('st:url-changed');
      scrollToTop();
      scrollListToLeft();
      const labelEl = btn.querySelector('.zop-top-filters__label');
      const label = (labelEl && labelEl.textContent ? labelEl.textContent : btn.textContent || '').trim();
      sendAnalytics('Sub-filter Rail Clicked', label, categoryMeta);
      // window.location.assign(url);
    }

    function scrollToTop() {
      const target = document.getElementById('collectionmodalcontainer');
      if (target) {
        const listHeight = list ? list.offsetHeight : 0;
        const yOffset = -(listHeight + 60); // adjust for fixed list height plus buffer
        const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }

    function scrollListToLeft() {
      if (list) {
        list.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
      }
    }

    function reorder(focusBtn){
      const active = [];
      const inactive = [];
      buttons.forEach(b => {
        (b.getAttribute('aria-pressed') === 'true' ? active : inactive).push(b);
      });
      if(active.length === 0) return; // Nothing to reorder
      const frag = document.createDocumentFragment();
      active.forEach(b => frag.appendChild(b));
      inactive.forEach(b => frag.appendChild(b));
      list.appendChild(frag);
      if(focusBtn){
        requestAnimationFrame(()=>{ try { focusBtn.focus({preventScroll:true}); } catch(e){} });
      }
    }
    buttons.forEach(btn => {
      btn.addEventListener('click', () => toggle(btn));
      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle(btn);
        }
      });
    });

    // Scroll show/hide manager: hide on scroll down, show on scroll up
    // Use a shared manager so multiple instances don't install many listeners
    if (!window.__zopTopFiltersScrollManager) {
      (function () {
        let lastY = window.scrollY || window.pageYOffset;
        let ticking = false;
        // Collect registered containers with their thresholds
        const containers = new Map(); // el -> threshold

        function onFrame() {
          ticking = false;
          const y = window.scrollY || window.pageYOffset;
          const delta = y - lastY;
          // threshold to avoid tiny scroll noise
          if (Math.abs(delta) > 8) {
            containers.forEach((threshold, c) => {
              try {
                const hide = delta > 0 && y > threshold; // hide when scrolling down and past component
                const arrow = document.querySelector('.st-collection-scroll-top');
                if (hide) {
                  c.classList.add('zop-top-filters--hidden');
                  if(arrow) {
                    arrow.style.top = "100px";
                  }
                } else {
                  c.classList.remove('zop-top-filters--hidden');
                  if(arrow) {
                    arrow.style.top = "200px";
                  }
                }
              } catch (e) {}
            });
            lastY = y;
          }
        }

        function onScroll() {
          if (!ticking) {
            ticking = true;
            requestAnimationFrame(onFrame);
          }
        }

        window.addEventListener('scroll', onScroll, { passive: true });

        window.__zopTopFiltersScrollManager = {
          register: (el) => {
            // Calculate the component's top offset in the document
            const threshold = el.offsetTop;
            containers.set(el, threshold);
          },
          unregister: (el) => containers.delete(el)
        };
      })();
    }

    // Register this container for scroll show/hide
    try {
      window.__zopTopFiltersScrollManager.register(container);
      // If the container was previously hidden, ensure the class is present
      if (container.classList.contains('zop-top-filters--hidden')) {
        // nothing else — animationend handler will keep it consistent
      }
      // Enable slide transitions after initial paint to avoid load jank
      setTimeout(() => container.classList.add('zop-top-filters--anim-ready'), 50);
    } catch (e) {}

    if (!impressionSent) {
      impressionSent = true;
      sendAnalytics('Sub-filter Rail Viewed', impressionLabel, categoryMeta);
    }
  }
  
  function handleShimmer() {
    const buttons = document.querySelectorAll('.zop-top-filters__item');
    if (!buttons.length) return;

    // Apply shimmer once on load, then clear to avoid extra listeners
    buttons.forEach(button => button.classList.add('zop-shimmer'));
    setTimeout(() => {
      buttons.forEach(button => button.classList.remove('zop-shimmer'));
    }, 200);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.zop-top-filters').forEach(init);
    handleShimmer();
  });
})();
